import { RefreshCw, Trash2, Copy, MoreVertical, Edit } from "lucide-react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Button } from "@/components/ui/button"
import { toast } from "sonner"
import { UnifiedEmailRecord } from "@/types/emails"
import { useState } from "react"
import { useDeleteEmailJob, useResendEmail } from "@/hooks/useEmailQueries"

interface ActionsMenuProps {
  item: UnifiedEmailRecord;
  type: 'sent' | 'failed';
  setSelectedEmail: (email: UnifiedEmailRecord | null) => void
}

export function ActionsMenu({ item, type, setSelectedEmail }: ActionsMenuProps) {
  const [isOpen, setIsOpen] = useState(false)

  const { mutate: resendEmail } = useResendEmail();
  const { mutate: deleteEmailJob } = useDeleteEmailJob();

  const handleCopyEmail = () => {
    const email = item.recipient_email
    navigator.clipboard.writeText(email)
    toast.success('Email copied to clipboard')
  }
  
  const handleCopySubject = () => {
    const subject = item.type === 'sent' 
    ? item.subject || ''
    : (item.final_subject || item.generated_subject || item.content.split(' - ')[0] || '')
    navigator.clipboard.writeText(subject)
    toast.success('Subject copied to clipboard')
  }


  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-8 w-8 p-0">
          <span className="sr-only">Open menu</span>
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">

        {type === 'failed' && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onSelect={() => resendEmail({ jobId: item.id }, { onSuccess: () => { setSelectedEmail(null) } })}>
              <RefreshCw className="mr-2 h-4 w-4" />
              Resend
            </DropdownMenuItem>
          </>
        )}
        {type === 'failed' && (
          <DropdownMenuItem onClick={() => setSelectedEmail(item)}>
            <Edit className="mr-2 size-4" />
            Edit
          </DropdownMenuItem>
        )}

        {type === 'failed' && (<DropdownMenuSeparator />)}
        
        <DropdownMenuItem onSelect={handleCopyEmail}>
          <Copy className="mr-2 size-4" />
          Copy Email
        </DropdownMenuItem>
        
        <DropdownMenuItem onSelect={handleCopySubject}>
          <Copy className="mr-2 h-4 w-4" />
          Copy Subject
        </DropdownMenuItem>
        
        
        {type === 'failed' && (<DropdownMenuSeparator />)}
        {type === 'failed' && (<DropdownMenuItem onSelect={() => deleteEmailJob(item.id)} className="text-red-600">
          <Trash2 className="mr-2 h-4 w-4" />
          Delete
        </DropdownMenuItem>)}
      </DropdownMenuContent>
    </DropdownMenu>
  )
} 